/*
 * AUTOGENERATED - DON'T EDIT
 * Your edits in this file will be overwritten in the next build!
 * Modify the docusaurus.config.js file at your site's root instead.
 */
export default {
  "title": "deck.gl",
  "tagline": "GPU-powered, highly performant large-scale data visualization",
  "url": "https://deck.gl",
  "baseUrl": "/deck.gl/",
  "onBrokenLinks": "throw",
  "markdown": {
    "hooks": {
      "onBrokenMarkdownLinks": "warn",
      "onBrokenMarkdownImages": "throw"
    },
    "format": "mdx",
    "mermaid": false,
    "emoji": true,
    "mdx1Compat": {
      "comments": true,
      "admonitions": true,
      "headingIds": true
    },
    "anchors": {
      "maintainCase": false
    }
  },
  "favicon": "/favicon.png",
  "organizationName": "visgl",
  "projectName": "deck.gl",
  "trailingSlash": false,
  "presets": [
    [
      "classic",
      {
        "docs": {
          "path": "../docs",
          "sidebarPath": "/Users/missx/Source/deck.gl/website/src/docs-sidebar.js",
          "editUrl": "https://github.com/visgl/deck.gl/tree/master/website"
        },
        "theme": {
          "customCss": [
            "/Users/missx/Source/deck.gl/website/src/styles.css",
            "/Users/missx/Source/deck.gl/website/node_modules/maplibre-gl/dist/maplibre-gl.css",
            "/Users/missx/Source/deck.gl/modules/widgets/dist/stylesheet.css"
          ]
        }
      }
    ]
  ],
  "plugins": [
    [
      "./ocular-docusaurus-plugin",
      {
        "debug": true,
        "resolve": {
          "modules": [
            "/Users/missx/Source/deck.gl/website/node_modules",
            "/Users/missx/Source/deck.gl/node_modules"
          ],
          "alias": {
            "@deck.gl/aggregation-layers": "/Users/missx/Source/deck.gl/modules/aggregation-layers/dist",
            "@deck.gl/arcgis": "/Users/missx/Source/deck.gl/modules/arcgis/dist",
            "@deck.gl/carto": "/Users/missx/Source/deck.gl/modules/carto/dist",
            "@deck.gl/core": "/Users/missx/Source/deck.gl/modules/core/dist",
            "@deck.gl/extensions": "/Users/missx/Source/deck.gl/modules/extensions/dist",
            "@deck.gl/geo-layers": "/Users/missx/Source/deck.gl/modules/geo-layers/dist",
            "@deck.gl/google-maps": "/Users/missx/Source/deck.gl/modules/google-maps/dist",
            "@deck.gl/json": "/Users/missx/Source/deck.gl/modules/json/dist",
            "@deck.gl/layers": "/Users/missx/Source/deck.gl/modules/layers/dist",
            "@deck.gl/mapbox": "/Users/missx/Source/deck.gl/modules/mapbox/dist",
            "@deck.gl/mesh-layers": "/Users/missx/Source/deck.gl/modules/mesh-layers/dist",
            "@deck.gl/react": "/Users/missx/Source/deck.gl/modules/react/dist",
            "@deck.gl/widgets": "/Users/missx/Source/deck.gl/modules/widgets/dist",
            "website-examples": "/Users/missx/Source/deck.gl/examples/website",
            "react": "/Users/missx/Source/deck.gl/website/node_modules/react",
            "react-dom": "/Users/missx/Source/deck.gl/website/node_modules/react-dom",
            "@luma.gl/webgl/constants": "/Users/missx/Source/deck.gl/node_modules/@luma.gl/webgl/dist/constants",
            "@luma.gl": "/Users/missx/Source/deck.gl/node_modules/@luma.gl",
            "@math.gl": "/Users/missx/Source/deck.gl/node_modules/@math.gl",
            "@loaders.gl/compression": "/Users/missx/Source/deck.gl/website/node_modules/@loaders.gl/compression",
            "@loaders.gl/i3s": "/Users/missx/Source/deck.gl/website/node_modules/@loaders.gl/i3s",
            "@loaders.gl/las": "/Users/missx/Source/deck.gl/website/node_modules/@loaders.gl/las",
            "@loaders.gl/obj": "/Users/missx/Source/deck.gl/website/node_modules/@loaders.gl/obj",
            "@loaders.gl/ply": "/Users/missx/Source/deck.gl/website/node_modules/@loaders.gl/ply",
            "@loaders.gl/schema": "/Users/missx/Source/deck.gl/node_modules/@loaders.gl/schema-utils",
            "@loaders.gl": "/Users/missx/Source/deck.gl/node_modules/@loaders.gl"
          }
        },
        "plugins": [
          {
            "keys": [
              "MapboxAccessToken",
              "GoogleMapsAPIKey",
              "GoogleMapsMapId"
            ],
            "defaultValues": {}
          },
          {
            "options": {
              "resourceRegExp": {}
            }
          }
        ],
        "module": {
          "rules": [
            {
              "test": {},
              "resolve": {
                "fullySpecified": false
              }
            }
          ]
        }
      }
    ],
    [
      "@docusaurus/plugin-content-docs",
      {
        "id": "examples",
        "path": "./src/examples",
        "routeBasePath": "examples",
        "sidebarPath": "/Users/missx/Source/deck.gl/website/src/examples-sidebar.js",
        "breadcrumbs": false,
        "docItemComponent": "/Users/missx/Source/deck.gl/website/src/components/example/doc-item-component.jsx"
      }
    ]
  ],
  "themeConfig": {
    "navbar": {
      "title": "deck.gl",
      "logo": {
        "alt": "vis.gl Logo",
        "src": "images/visgl-logo-dark.png",
        "srcDark": "images/visgl-logo-light.png"
      },
      "items": [
        {
          "to": "/examples",
          "position": "left",
          "label": "Examples"
        },
        {
          "to": "/docs",
          "position": "left",
          "label": "Docs"
        },
        {
          "to": "/showcase",
          "position": "left",
          "label": "Showcase"
        },
        {
          "to": "https://medium.com/vis-gl",
          "label": "Blog",
          "position": "left"
        },
        {
          "href": "https://github.com/visgl/deck.gl",
          "label": "GitHub",
          "position": "right"
        },
        {
          "type": "html",
          "position": "right",
          "value": "<a href=\"https://openvisualization.org\" target=\"_blank\" style=\"content: ''; height: 24px; width: 80px; background-image: url('/openjs-foundation.svg'); background-repeat: no-repeat;  background-size: 80px 24px; display: flex\"></a>"
        }
      ],
      "hideOnScroll": false
    },
    "footer": {
      "style": "dark",
      "links": [
        {
          "title": "Resources",
          "items": [
            {
              "label": "API Reference",
              "to": "/docs/api-reference/core/deck"
            },
            {
              "label": "Starter templates",
              "href": "https://github.com/visgl/deck.gl/tree/master/examples/get-started"
            },
            {
              "label": "Playground",
              "href": "/playground"
            },
            {
              "label": "Codepen demos",
              "href": "https://codepen.io/vis-gl/"
            }
          ]
        },
        {
          "title": "Other vis.gl Libraries",
          "items": [
            {
              "label": "deck.gl-community",
              "href": "https://visgl.github.io/deck.gl-community/"
            },
            {
              "label": "luma.gl",
              "href": "https://luma.gl"
            },
            {
              "label": "loaders.gl",
              "href": "https://loaders.gl"
            },
            {
              "label": "react-map-gl",
              "href": "https://visgl.github.io/react-map-gl"
            }
          ]
        },
        {
          "title": "More",
          "items": [
            {
              "label": "Slack workspace",
              "href": "https://slack-invite.openjsf.org"
            },
            {
              "label": "vis.gl blog on Medium",
              "href": "https://medium.com/vis-gl"
            },
            {
              "label": "GitHub",
              "href": "https://github.com/visgl/deck.gl"
            }
          ]
        }
      ],
      "copyright": "<div class=\"footer-copy\">Copyright <a href=\"https://openjsf.org\">OpenJS Foundation</a> and vis.gl contributors. All rights reserved. The <a href=\"https://openjsf.org\">OpenJS Foundation</a> has registered trademarks and uses trademarks. For a list of trademarks of the <a href=\"https://openjsf.org\">OpenJS Foundation</a>, please see our <a href=\"https://trademark-policy.openjsf.org\">Trademark Policy</a> and <a href=\"https://trademark-list.openjsf.org\">Trademark List</a>. Trademarks and logos not indicated on the <a href=\"https://trademark-list.openjsf.org\">list of OpenJS Foundation trademarks</a> are trademarks&trade; or registered&reg; trademarks of their respective holders. Use of them does not imply any affiliation with or endorsement by them.<br><br><a href=\"https://openjsf.org\">The OpenJS Foundation</a> | <a href=\"https://terms-of-use.openjsf.org\">Terms of Use</a> | <a href=\"https://privacy-policy.openjsf.org\">Privacy Policy</a> | <a href=\"https://bylaws.openjsf.org\">Bylaws</a> | <a href=\"https://code-of-conduct.openjsf.org\">Code of Conduct</a> | <a href=\"https://trademark-policy.openjsf.org\">Trademark Policy</a> | <a href=\"https://trademark-list.openjsf.org\">Trademark List</a> | <a href=\"https://www.linuxfoundation.org/cookies\">Cookie Policy</a></div>"
    },
    "algolia": {
      "appId": "8EVYAVB4KT",
      "apiKey": "a3fe1388353d733272ffdf148c53eeaa",
      "indexName": "deck",
      "contextualSearch": true,
      "searchPagePath": false,
      "searchParameters": {}
    },
    "prism": {
      "theme": {
        "plain": {
          "color": "#403f53",
          "backgroundColor": "#FBFBFB"
        },
        "styles": [
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(162, 191, 252)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgba(239, 83, 80, 0.56)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "inserted",
              "attr-name"
            ],
            "style": {
              "color": "rgb(72, 118, 214)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(152, 159, 177)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "builtin",
              "char",
              "constant",
              "url"
            ],
            "style": {
              "color": "rgb(72, 118, 214)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(201, 103, 101)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(170, 9, 130)"
            }
          },
          {
            "types": [
              "punctuation"
            ],
            "style": {
              "color": "rgb(153, 76, 195)"
            }
          },
          {
            "types": [
              "function",
              "selector",
              "doctype"
            ],
            "style": {
              "color": "rgb(153, 76, 195)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "class-name"
            ],
            "style": {
              "color": "rgb(17, 17, 17)"
            }
          },
          {
            "types": [
              "tag"
            ],
            "style": {
              "color": "rgb(153, 76, 195)"
            }
          },
          {
            "types": [
              "operator",
              "property",
              "keyword",
              "namespace"
            ],
            "style": {
              "color": "rgb(12, 150, 155)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(188, 84, 84)"
            }
          }
        ]
      },
      "darkTheme": {
        "plain": {
          "color": "#d6deeb",
          "backgroundColor": "#011627"
        },
        "styles": [
          {
            "types": [
              "changed"
            ],
            "style": {
              "color": "rgb(162, 191, 252)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "deleted"
            ],
            "style": {
              "color": "rgba(239, 83, 80, 0.56)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "inserted",
              "attr-name"
            ],
            "style": {
              "color": "rgb(173, 219, 103)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "comment"
            ],
            "style": {
              "color": "rgb(99, 119, 119)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "string",
              "url"
            ],
            "style": {
              "color": "rgb(173, 219, 103)"
            }
          },
          {
            "types": [
              "variable"
            ],
            "style": {
              "color": "rgb(214, 222, 235)"
            }
          },
          {
            "types": [
              "number"
            ],
            "style": {
              "color": "rgb(247, 140, 108)"
            }
          },
          {
            "types": [
              "builtin",
              "char",
              "constant",
              "function"
            ],
            "style": {
              "color": "rgb(130, 170, 255)"
            }
          },
          {
            "types": [
              "punctuation"
            ],
            "style": {
              "color": "rgb(199, 146, 234)"
            }
          },
          {
            "types": [
              "selector",
              "doctype"
            ],
            "style": {
              "color": "rgb(199, 146, 234)",
              "fontStyle": "italic"
            }
          },
          {
            "types": [
              "class-name"
            ],
            "style": {
              "color": "rgb(255, 203, 139)"
            }
          },
          {
            "types": [
              "tag",
              "operator",
              "keyword"
            ],
            "style": {
              "color": "rgb(127, 219, 202)"
            }
          },
          {
            "types": [
              "boolean"
            ],
            "style": {
              "color": "rgb(255, 88, 116)"
            }
          },
          {
            "types": [
              "property"
            ],
            "style": {
              "color": "rgb(128, 203, 196)"
            }
          },
          {
            "types": [
              "namespace"
            ],
            "style": {
              "color": "rgb(178, 204, 214)"
            }
          }
        ]
      },
      "additionalLanguages": [],
      "magicComments": [
        {
          "className": "theme-code-block-highlighted-line",
          "line": "highlight-next-line",
          "block": {
            "start": "highlight-start",
            "end": "highlight-end"
          }
        }
      ]
    },
    "colorMode": {
      "defaultMode": "light",
      "disableSwitch": false,
      "respectPrefersColorScheme": false
    },
    "docs": {
      "versionPersistence": "localStorage",
      "sidebar": {
        "hideable": false,
        "autoCollapseCategories": false
      }
    },
    "blog": {
      "sidebar": {
        "groupByYear": true
      }
    },
    "metadata": [],
    "tableOfContents": {
      "minHeadingLevel": 2,
      "maxHeadingLevel": 3
    }
  },
  "baseUrlIssueBanner": true,
  "i18n": {
    "defaultLocale": "en",
    "path": "i18n",
    "locales": [
      "en"
    ],
    "localeConfigs": {}
  },
  "future": {
    "v4": {
      "removeLegacyPostBuildHeadAttribute": false,
      "useCssCascadeLayers": false
    },
    "experimental_faster": {
      "swcJsLoader": false,
      "swcJsMinimizer": false,
      "swcHtmlMinimizer": false,
      "lightningCssMinimizer": false,
      "mdxCrossCompilerCache": false,
      "rspackBundler": false,
      "rspackPersistentCache": false,
      "ssgWorkerThreads": false
    },
    "experimental_storage": {
      "type": "localStorage",
      "namespace": false
    },
    "experimental_router": "browser"
  },
  "onBrokenAnchors": "warn",
  "onDuplicateRoutes": "warn",
  "staticDirectories": [
    "static"
  ],
  "customFields": {},
  "themes": [],
  "scripts": [],
  "headTags": [],
  "stylesheets": [],
  "clientModules": [],
  "titleDelimiter": "|",
  "noIndex": false
};
